import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpEvent, HttpRequest } from '@angular/common/http';
import { Product, PaginatedResult } from '../models/product';
import { map, Observable } from 'rxjs';
import { baseURL } from '../constants/base.url';


@Injectable({
  providedIn: 'root'
})
export class ProductService {

  constructor(private http: HttpClient) { }

  // GET list with filters + pagination + sort
  getProducts(params: {
    page?: number;
    limit?: number;
    productType?: string;
    categoryId?: string;
    supplierId?: string;
    brand?: string;
    minPrice?: number;
    maxPrice?: number;
    tag?: string;
    search?: string;
    sort?: string;
  } = {}): Observable<PaginatedResult<Product>> {
    let httpParams = new HttpParams();
    Object.keys(params).forEach(k => {
      const val = (params as any)[k];
      if (val !== undefined && val !== null && val !== '') {
        httpParams = httpParams.set(k, String(val));
      }
    });
    return this.http.get<PaginatedResult<Product>>(`${baseURL}products`, { params: httpParams });
  }

  // ProductService
  getAllProducts(): Observable<Product[]> {
    return this.http.get<{ success: boolean, data: { products: Product[] } }>(`${baseURL}products`)
      .pipe(
        map(res => res.data?.products || [])
      );
  }


  getProduct(id: string): Observable<{ success: boolean; data: Product }> {
    return this.http.get<{ success: boolean; data: Product }>(`${baseURL}products/${id}`);
  }

  // Create product with FormData (files + json fields)
  // createProduct(payload: { product: Partial<Product>, thumbnail?: File, images?: File[] }): Observable<any> {
  //   const fd = this.buildFormData(payload);
  //   return this.http.post(`${baseURL}products`, fd);
  // }
  createProduct(formData: FormData): Observable<any> {
    return this.http.post(`${baseURL}products`, formData);
  }

  updateProduct(id: string, payload: { product: Partial<Product>, thumbnail?: File | null, images?: File[] | null }): Observable<any> {
    const fd = this.buildFormData(payload);
    return this.http.put(`${baseURL}products/${id}`, fd);
  }

  deleteProduct(id: string): Observable<any> {
    return this.http.delete(`${baseURL}products/${id}`);
  }

  // helper for FormData: converts nested attributes to JSON strings where needed
  private buildFormData(payload: { product: Partial<Product>, thumbnail?: File | null, images?: File[] | null }): FormData {
    const fd = new FormData();
    const product = payload.product || {};

    // Append primitive fields
    for (const key of Object.keys(product)) {
      const val = (product as any)[key];
      if (val === undefined || val === null) continue;

      // attributes is object -> stringify
      if (key === 'attributes' || typeof val === 'object' && !Array.isArray(val) && !(val instanceof File)) {
        fd.append(key, JSON.stringify(val));
      } else if (Array.isArray(val)) {
        // arrays (images supplied as URLs in product) — append as comma string or multiple keys
        fd.append(key, JSON.stringify(val));
      } else {
        fd.append(key, String(val));
      }
    }

    // files
    if (payload.thumbnail) {
      fd.append('thumbnail', payload.thumbnail, payload.thumbnail.name);
    }
    if (payload.images && payload.images.length) {
      payload.images.forEach((f, idx) => fd.append('images', f, f.name));
    }
    return fd;
  }

  // optional: upload progress helper
  uploadWithProgress(fd: FormData): Observable<HttpEvent<any>> {
    const req = new HttpRequest('POST', `${baseURL}products`, fd, {
      reportProgress: true
    });
    return this.http.request(req);
  }
}